import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

import { Services } from '@/infra/services';
import { type Response } from '@/infra/services/catalog/crosses/get-crosses-services';
import { type ItemId } from '@/infra/services/catalog/model';

type CrossesServicesQueryOptions = Omit<
  UseQueryOptions<Response>,
  'queryKey' | 'queryFn'
>;

const useCrossesServices = (
  itemId: ItemId,
  options?: CrossesServicesQueryOptions
) => {
  const result = useQuery<Response>({
    queryKey: ['get-crosses-services', itemId],
    queryFn: async () =>
      await Services.Catalog.Crosses.getCrossesServices({
        itemId,
      }),
    ...options,
  });

  return result;
};

export default useCrossesServices;
